import { createSelector } from 'reselect';
import { ITouchpointDisplaysState, ITouchpointDisplay } from './types';

export const selectSyncState = (state: ITouchpointDisplaysState) => state.syncing;
export const selectLoadedState = (state: ITouchpointDisplaysState) => state.loaded;
export const selectSyncError = (state: ITouchpointDisplaysState) => state.error;

export const selectTouchpointDisplays = (state: ITouchpointDisplaysState) =>
  state.touchpointDisplays;
export const selectTouchpointDisplayItem = (state: ITouchpointDisplaysState) =>
  state.touchpointDisplay;

export const selectCreateInitiatedState = (state: ITouchpointDisplaysState) =>
  state.createInitiated;
export const selectUpdateInitiatedState = (state: ITouchpointDisplaysState) =>
  state.updateInitiated;
export const selectDeleteInitiatedState = (state: ITouchpointDisplaysState) =>
  state.deleteInitiated;

export const selectCreatedState = (state: ITouchpointDisplaysState) =>
  state.touchpointDisplayCreated;
export const selectUpdatedState = (state: ITouchpointDisplaysState) =>
  state.touchpointDisplayUpdated;
export const selectDeletedState = (state: ITouchpointDisplaysState) =>
  state.touchpointDisplayDeleted;

export const selectIndexedTouchpointDisplays = createSelector(
  selectTouchpointDisplays,
  (touchpointDisplays) =>
    touchpointDisplays.reduce(
      (indexed: { [key: string]: ITouchpointDisplay }, touchpointDisplay: ITouchpointDisplay) => {
        if (touchpointDisplay.displayId) {
          indexed[touchpointDisplay.displayId] = touchpointDisplay;
        }
        return indexed;
      },
      {}
    )
);
export const selectTouchpointDisplay = createSelector(
  [selectIndexedTouchpointDisplays, (_: ITouchpointDisplaysState, id: string) => id],
  (indexedTouchpointDisplays, id) => indexedTouchpointDisplays[id]
);
